module.exports = __webpack_public_path__ + "img/mobilewarrior_notcompleted.bf10dc9d.svg";